import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { getBackgroundColor } from './accordionUtil';
import { colors, calculateSpacing } from '@vds-core/theme';
import { BodyConfig, TypographyConfig } from '@vds-core/typography';
import { withVDSManager } from '@vds-core/utilities';
import AccordionAnimation from '../util/AccordionAnimation';
var typescale = TypographyConfig.getTypescale();
var SlideOutContent = /*#__PURE__*/keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(0px);\n  }\n\n  to {\n    transform: translateY(-16px);\n  }\n"])));
var SlideInContent = /*#__PURE__*/keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(-20px);\n  }\n\n  to {\n    transform: translateY(0px);\n  }\n"])));
var propTypes = {
  /**
   * @ignore
   */
  active: PropTypes.bool,

  /**
   * @ignore
   */
  backgroundColor: PropTypes.string,

  /**
   * @ignore
   */
  children: PropTypes.node.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,
  //DEPRECATED

  /**
   * @ignore
   */
  groupId: PropTypes.string,

  /**
   * @ignore
   */
  inverted: PropTypes.bool,

  /**
   * @ignore
   */
  viewport: PropTypes.oneOf(['mobile', 'desktop', 'tablet']),

  /**
   * @ignore
   */
  paddingTop: PropTypes.number,

  /**
   * @ignore
   */
  buttonHitArea: PropTypes.bool,

  /**
   * @ignore
   */
  transitionStates: PropTypes.bool,

  /**
   * @ignore
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   */
  calcTypography: PropTypes.func,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object
};
var bodyMediumDesktop = BodyConfig.getStyles(TypographyConfig.getTypescale(), 'desktop', 'medium');
var bodyMediumMobile = BodyConfig.getStyles(TypographyConfig.getTypescale(), 'mobile', 'medium');

function _calcTypography(viewport) {
  var type = BodyConfig.getStyles(typescale, viewport, 'medium');
  return type;
}

var defaultProps = {
  active: false,
  inverted: false,
  backgroundColor: null,
  className: null,
  groupId: null,
  viewport: 'desktop',
  //1.0
  buttonHitArea: false,
  paddingTop: 6,
  transitionStates: false,
  calcTypography: _calcTypography,
  colorConfig: colors
};
var ChildWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "ChildWrapper",
  componentId: "sc-19df7fd-0"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
  var transitionStates = _ref.transitionStates,
      active = _ref.active;
  return transitionStates && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      transition: padding 350ms ease;\n      animation-name: ", ";\n      animation-duration: 350ms;\n      animation-delay: 100ms;\n      animation-timing-function: ease;\n    "])), active ? SlideInContent : SlideOutContent);
});
var StyledAccordionDetail = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledAccordionDetail",
  componentId: "sc-19df7fd-1"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  background-color: ", ";\n  color: ", ";\n  line-height: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  letter-spacing: ", ";\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  transition: padding 350ms;\n  > * {\n    margin: 0;\n    &:not(:last-child) {\n      margin-bottom: ", ";\n    }\n  }\n  &:active,\n  &:hover {\n    outline: none;\n  }\n  ", ";\n"])), function (_ref2) {
  var active = _ref2.active,
      paddingTop = _ref2.paddingTop;
  return active ? calculateRem(paddingTop) : 0;
}, function (props) {
  return getBackgroundColor(props);
}, function (_ref3) {
  var inverted = _ref3.inverted,
      colorConfig = _ref3.colorConfig;
  return inverted ? colorConfig.white : colorConfig.black;
}, function (_ref4) {
  var bodyType = _ref4.bodyType;
  return calculateRem(bodyType.lineHeight);
}, function (_ref5) {
  var bodyType = _ref5.bodyType;
  return calculateRem(bodyType.fontSize);
}, function (_ref6) {
  var bodyType = _ref6.bodyType;
  return bodyType.fontFamily;
}, function (_ref7) {
  var bodyType = _ref7.bodyType;
  return bodyType.letterSpacing ? calculateRem(bodyType.letterSpacing) : '0';
}, calculateRem(8), function (_ref8) {
  var buttonHitArea = _ref8.buttonHitArea,
      active = _ref8.active;
  return buttonHitArea && active && " \n    padding-bottom: 23px;\n    padding-top: 0;\n  ";
});

var AccordionDetail = /*#__PURE__*/function (_Component) {
  _inherits(AccordionDetail, _Component);

  var _super = _createSuper(AccordionDetail);

  function AccordionDetail() {
    var _this;

    _classCallCheck(this, AccordionDetail);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "isAndroidDevice", function () {
      return typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('android') > -1;
    }());

    return _this;
  }

  _createClass(AccordionDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var groupId = this.props.groupId;
      this.accordionDetailId = "accordionDetail_".concat(groupId);
      this.accordionAliasId = "accordionHeader_".concat(groupId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          backgroundColor = _this$props.backgroundColor,
          children = _this$props.children,
          className = _this$props.className,
          groupId = _this$props.groupId,
          inverted = _this$props.inverted,
          viewport = _this$props.viewport,
          paddingTop = _this$props.paddingTop,
          buttonHitArea = _this$props.buttonHitArea,
          transitionStates = _this$props.transitionStates,
          calcTypography = _this$props.calcTypography,
          colorConfig = _this$props.colorConfig;
      var bodyType = calcTypography(viewport || 'desktop');
      var height = active ? 'auto' : 0;
      return /*#__PURE__*/React.createElement(StyledAccordionDetail, {
        viewport: viewport,
        active: active,
        backgroundColor: backgroundColor,
        className: className,
        inverted: inverted,
        id: this.accordionDetailId,
        "aria-labelledby": this.accordionAliasId,
        onClick: this._onClick,
        paddingTop: paddingTop,
        buttonHitArea: buttonHitArea,
        transitionStates: transitionStates,
        bodyType: bodyType,
        colorConfig: colorConfig,
        tabIndex: active ? undefined : -1,
        role: "region",
        "aria-hidden": !active && this.isAndroidDevice
      }, /*#__PURE__*/React.createElement(AccordionAnimation, {
        height: height,
        active: active
      }, /*#__PURE__*/React.createElement(ChildWrapper, {
        transitionStates: transitionStates,
        active: active
      }, children)));
    }
  }]);

  return AccordionDetail;
}(Component);

_defineProperty(AccordionDetail, "componentType", 'AccordionDetail');

AccordionDetail.propTypes = propTypes;
AccordionDetail.defaultProps = defaultProps;
export default AccordionDetail;